import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "48",
  height: "15",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "currentColor",
      "fill-rule": "nonzero"
    }, [
      _createElementVNode("path", { d: "M19.534.95 17.16 14.74h3.797L23.333.95m-9.356.016L10.26 10.37l-.396-1.42c-.734-1.71-2.815-4.168-5.26-5.715l3.399 11.499 4.017-.008L17.996.962l-4.02.004h.001Z" }),
      _createElementVNode("path", { d: "M8.421 1.953C8.2 1.113 7.564.863 6.768.833H.88l-.048.274c4.581 1.101 7.612 3.751 8.87 6.938L8.42 1.953Zm22.607 1.642a7.067 7.067 0 0 1 2.84.527l.343.161.514-2.99c-.754-.278-1.93-.577-3.402-.577-3.75 0-6.394 1.87-6.415 4.551-.025 1.98 1.883 3.085 3.324 3.746 1.48.676 1.976 1.107 1.967 1.713-.01.922-1.177 1.344-2.269 1.344-1.52 0-2.328-.208-3.575-.722l-.488-.22-.536 3.086c.89.386 2.53.717 4.23.735 3.995 0 6.586-1.848 6.613-4.712.015-1.567-.996-2.763-3.19-3.744-1.328-.639-2.14-1.064-2.132-1.71 0-.573.689-1.185 2.174-1.185l.002-.003ZM44.468.966h-2.934c-.911 0-1.589.246-1.988 1.145L33.91 14.748h3.985s.651-1.698.8-2.072l4.86.006c.114.48.463 2.065.463 2.065h3.52L44.468.967Zm-4.682 8.889L41.297 6c-.019.038.311-.798.506-1.318l.256 1.19.882 3.98h-3.154l-.001.002Z" })
    ], -1)
  ])))
}
export default { render: render }